module.exports = __webpack_public_path__ + "img/6.11432d96.png";